/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Timezone = {
    Pacific_Auckland: 'Pacific/Auckland',
    Asia_Singapore: 'Asia/Singapore',
    Australia_Perth: 'Australia/Perth',
    Australia_Canberra: 'Australia/Canberra',
    Australia_Sydney: 'Australia/Sydney',
    Australia_Darwin: 'Australia/Darwin',
    Australia_Brisbane: 'Australia/Brisbane',
    Australia_Adelaide: 'Australia/Adelaide',
    Australia_Hobart: 'Australia/Hobart',
    Australia_Melbourne: 'Australia/Melbourne',
    UTC: 'UTC'
} as const;
export type Timezone = typeof Timezone[keyof typeof Timezone];


export function TimezoneFromJSON(json: any): Timezone {
    return TimezoneFromJSONTyped(json, false);
}

export function TimezoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Timezone {
    return json as Timezone;
}

export function TimezoneToJSON(value?: Timezone | null): any {
    return value as any;
}

